import { render } from "./TwoFactorEnableModal.vue?vue&type=template&id=129e3bfe&scoped=true&ts=true"
import script from "./TwoFactorEnableModal.vue?vue&type=script&lang=ts"
export * from "./TwoFactorEnableModal.vue?vue&type=script&lang=ts"

import "./TwoFactorEnableModal.vue?vue&type=style&index=0&id=129e3bfe&scoped=true&lang=css"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129e3bfe"]])

export default __exports__